import { Icon } from '@/components/Icon'
import styles from './Hero.module.css'

export function Hero() {
  return (
    <section id="inicio" className={styles.hero}>
      <div className={styles.glow} aria-hidden="true" />
      <div className={`container ${styles.inner}`}>
        <div className={styles.copy}>
          <p className={styles.kicker}>Desarrollo personal y profesional · Liderazgo · Equipos</p>
          <h1 className={styles.title}>Emilia Hidalgo</h1>
          <p className={styles.tagline}>Personas que avanzan. Equipos que crecen.</p>
          <p className={styles.lead}>
            Desarrollo personal y profesional, empleabilidad, liderazgo y herramientas para construir
            mejores experiencias de trabajo. Contenidos, talleres y experiencias diseñadas para
            transformar objetivos en acciones.
          </p>
          <div className={styles.actions}>
            <a href="#charlas" className="btn btn--primary btn--lg">
              Conoce mis charlas y talleres
            </a>
            <a href="#recursos" className="btn btn--outline btn--lg">
              Recursos para ti
            </a>
          </div>
        </div>

        <div className={styles.figure}>
          <div className={styles.photoWrap}>
            <img
              src="/images/emilia-oficina.png"
              alt="Emilia Hidalgo en su oficina de psicología organizacional"
              width={1712}
              height={960}
              fetchPriority="high"
            />
          </div>
          <div className={styles.badge}>
            <span className={styles.badgeDot} />
            <div>
              <strong>Charlas · Talleres · Capacitaciones</strong>
              <span>Para personas y organizaciones</span>
            </div>
          </div>
        </div>
      </div>

      <a href="#que-encuentras" className={styles.scroll} aria-label="Ir al contenido">
        <Icon name="arrow" size={18} />
      </a>
    </section>
  )
}
